import { useSelector } from 'react-redux';
import {
  brandSelector,
  channelSelector,
  languageSelector,
  userTokenSelector,
} from '../../redux/reducers/app/params';
import { isLocalGameLaunchMode } from '../../redux/reducers/app/initialization';
import { operatorIdSelector } from '../../redux/reducers/app/configuration';
import { HTTP_HEADERS } from '../../constants/api';
import {
  APP_STORE_REVIEW_HEADER_NAME,
  APP_STORE_REVIEW_HEADER_VALUE,
} from '../../constants/appStoreReview';

export const useCommonHeaders = () => {
  const channel = useSelector(channelSelector);
  const brand = useSelector(brandSelector);
  const language = useSelector(languageSelector);
  const token = useSelector(userTokenSelector);
  const operatorId = useSelector(operatorIdSelector);
  const localGameLaunchMode = useSelector(isLocalGameLaunchMode);

  const headers = {
    [HTTP_HEADERS.CONTENT_TYPE]: 'application/json',
    [HTTP_HEADERS.CHANNEL]: channel,
    [HTTP_HEADERS.BRAND]: brand,
    [HTTP_HEADERS.LANGUAGE]: language,
    [HTTP_HEADERS.OPERATOR_ID]: operatorId,
  };

  if (token) {
    headers[HTTP_HEADERS.AUTHORIZATION] = `Token ${token}`;
  }

  if (localGameLaunchMode) {
    headers[APP_STORE_REVIEW_HEADER_NAME] = APP_STORE_REVIEW_HEADER_VALUE;
  }

  return headers;
};
